import { render, staticRenderFns } from "./EventTrends.vue?vue&type=template&id=19f6640c&scoped=true"
import script from "./EventTrends.vue?vue&type=script&lang=js"
export * from "./EventTrends.vue?vue&type=script&lang=js"
import style0 from "./EventTrends.vue?vue&type=style&index=0&id=19f6640c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f6640c",
  null
  
)

export default component.exports